export default __webpack_public_path__ + "static/media/net-contribution-icon.f2314ae4.svg";